import { render, staticRenderFns } from "./205.vue?vue&type=template&id=3bcb885a&scoped=true&"
var script = {}
import style0 from "./205.vue?vue&type=style&index=0&id=3bcb885a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb885a",
  null
  
)

export default component.exports